import script from "./PhoneVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneVerify.vue?vue&type=script&setup=true&lang=js"

import "./PhoneVerify.vue?vue&type=style&index=0&id=23d2b9b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d2b9b6"]])

export default __exports__